import SelectSupplierModal from "@/components/supplier/SelectSupplierModal";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { SUPPLIER_STAGE } from "@/constants";
import { useModalBehavior } from "@/hooks/behaviors";
import { usePerformaceEvaluationCategory } from "@/hooks/services";
import { SupplierUserSimpleListItem } from "@/types/apis";
import { Col, Form, Input, Row, Select } from "antd";
import type { SupplierPerformanceBasicFormType } from "../../type";
import styles from "./SupplierBasicFormFields.module.less";
import { useTranslation } from "react-i18next";

export function SupplierBasicFormFields() {
  const form = Form.useFormInstance<SupplierPerformanceBasicFormType>();
  const { categories } = usePerformaceEvaluationCategory();
  const { t } = useTranslation("supplierPerformance");

  const categoryOptions = categories?.map((c) => ({
    label: c.supplierCategoryName,
    value: c.supplierCategoryId,
  }));

  const {
    open: supplierUserModalOpen,
    openModal: openSupplierUserModal,
    closeModal: closeSupplierUserModal,
  } = useModalBehavior();

  const onSelectSupplierModalClose = (
    pickedSupplier?: SupplierUserSimpleListItem,
  ) => {
    if (pickedSupplier) {
      form.setFieldsValue({
        supplierCode: pickedSupplier.supplierCode,
        supplierName: pickedSupplier.supplierName,
        supplierUserId: pickedSupplier.id,
      });
    }
    closeSupplierUserModal();
  };

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("供应商基本信息")} />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<SupplierPerformanceBasicFormType>
              name="supplierUserId"
              label={t("供应商id")}
              hidden
            >
              <Input />
            </Form.Item>
            <Form.Item<SupplierPerformanceBasicFormType>
              name="supplierCode"
              label={t("供应商编号")}
              rules={[
                {
                  required: true,
                  message: t("请输入供应商编号"),
                },
              ]}
            >
              <Input
                placeholder={t("请输入供应商编号")}
                readOnly
                onClick={openSupplierUserModal}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<SupplierPerformanceBasicFormType>
              name="supplierName"
              label={t("供应商名称")}
              rules={[
                {
                  required: true,
                  message: t("请输入供应商名称"),
                },
              ]}
            >
              <Input
                placeholder={t("请输入供应商名称")}
                readOnly
                onClick={openSupplierUserModal}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<SupplierPerformanceBasicFormType>
              name="purchaseAmount"
              label={t("采购金额")}
              rules={[
                {
                  required: true,
                  message: t("请选择采购金额"),
                },
              ]}
            >
              <Select
                options={[
                  { label: "高", value: "高" },
                  { label: "低", value: "低" },
                ]}
                placeholder={t("请选择")}
              ></Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<SupplierPerformanceBasicFormType>
              name="riskLevel"
              label={t("供应风险")}
              rules={[
                {
                  required: true,
                  message: t("请选择供应风险"),
                },
              ]}
            >
              <Select
                options={[
                  { label: "高", value: "高" },
                  { label: "低", value: "低" },
                ]}
                placeholder={t("请选择")}
              ></Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<SupplierPerformanceBasicFormType>
              name="supplierCategoryId"
              label={t("供应商类别")}
              rules={[
                {
                  required: true,
                  message: t("请选择供应商类别"),
                },
              ]}
            >
              <Select
                options={categoryOptions}
                placeholder={t("请选择")}
              ></Select>
            </Form.Item>
          </Col>
        </Row>
      </div>

      <SelectSupplierModal
        fixedSupplierStage={SUPPLIER_STAGE.ONBOARDING}
        open={supplierUserModalOpen}
        onClose={onSelectSupplierModalClose}
      />
    </div>
  );
}
